import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'
import { cloneDeep, set } from 'lodash'
import vitAPI from '../api'

const receiveCalendarAvailability = createAction('calendarAvailability/receive')
const fetchCalendarData = createAction('calendarAvailability/fetch')

// stored as state[searchKey] = {loading: bool, data: {'DD': cost}}
export const calendarAvailabilityReducer = createReducer({}, (builder) => {
  builder
    .addCase(fetchCalendarData, (state, action) => {
      const currentState = cloneDeep(state)
      set(currentState, [action.payload.storeKey, 'loading'], true)
      return currentState
    })
    .addCase(receiveCalendarAvailability, (state, action) => {
      const currentState = cloneDeep(state)
      set(currentState, [action.payload.storeKey], {
        loading: false,
        data: action.payload.data,
      })
      return currentState
    })
})

const selectCalendarAvailabilityState = (state) => state.calendarData

export const selectPropertyCalendarAvailability = createSelector(
  [selectCalendarAvailabilityState, (state, searchKey) => searchKey],
  (state, searchKey) => state?.[searchKey]
)

export const getCalendarData =
  ({ storeKey, searchParams }) =>
  (dispatch) => {
    dispatch(
      fetchCalendarData({
        storeKey,
      })
    )

    return vitAPI.getCalendar(searchParams).then(({ data }) => {
      dispatch(
        receiveCalendarAvailability({
          storeKey,
          data,
        })
      )
    })
  }
